import React from 'react';
import Header from 'components/ui/Header';
import Footer from 'components/ui/Footer';

/**
 * PublicLayout wraps all public-facing pages with the top navbar and footer.
 * Authenticated dashboard pages can use a separate DashboardLayout that
 * includes a left sidebar without touching this component.
 */
const PublicLayout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default PublicLayout;
